import { render, staticRenderFns } from "./AlertConfigs.vue?vue&type=template&id=6bb2bf06"
import script from "./AlertConfigs.vue?vue&type=script&lang=js"
export * from "./AlertConfigs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bb2bf06')) {
      api.createRecord('6bb2bf06', component.options)
    } else {
      api.reload('6bb2bf06', component.options)
    }
    module.hot.accept("./AlertConfigs.vue?vue&type=template&id=6bb2bf06", function () {
      api.rerender('6bb2bf06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/invoices/AlertConfigs.vue"
export default component.exports